export const DEFAULT_ICON_SIZE = 32
export const DONATION_ID_PREFIX = 'id-'
